import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AvailableInstrumentTogglerComponent } from './available-instrument-toggler.component';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { HtmlFormatPipeModule } from 'src/app/pipes/html-format-pipe.module';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { BaseChartDirective } from 'ng2-charts';

@NgModule({
  declarations: [
    AvailableInstrumentTogglerComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    AngularSvgIconModule,
    HtmlFormatPipeModule,
    BaseChartDirective,
  ],
  providers: [
    TranslatePipe,
  ],
  exports: [
    AvailableInstrumentTogglerComponent
  ]
})
export class AvailableInstrumentTogglerModule { }
